export const BASE_URL =
  import.meta.env.MODE === "development" ? "" : import.meta.env.VITE_SERVER_URL;

export const TAG = {
  EXPERIMENTS: "Experiments",
  USER: "User",
  SHIPPING_ADDRESS: "ShippingAddress",
  STRIPE: "Stripe",
  PAYMENT_INFORMATION: "PaymentInformation",
  STATES: "States",
  VOUCHED_VERIFICATION: "VouchedVerification",
  QUESTION: "Question",
  PAYMENT_METHODS: "PaymentMethods",
  ANSWERS: "Answers",
  ANSWER: "Answer",
  SUBSCRIPTIONS: "Subscriptions",
  MESSAGE_THREADS: "MassageThreads",
  MESSAGES: "Messages",
  ONLINE_VISITS: "OnlineVisits",
  ONLINE_VISIT: "OnlineVisit",
  NAVIGATION: "Navigation",
  TASKS: "Tasks",
  LATEST_ORDER: "LatestOrder",
  ORDERS: "Orders",
  FILE_STORAGE: "FileStorage",
  ID_VERIFICATION: "IdVerification",
  PRESCRIPTIONS: "Prescriptions",
  PRESCRIPTION: "Prescription",
  CHARGES: "Charges",
  PATIENT_COUPONS: "PatientCoupons",
  PRODUCT_TITRATION: "ProductTitration",
  PATIENT_RATINGS: "PatientRatings",
  REFERRAL_CODE: "ReferralCode",
  PATIENT_WEIGHTS: "PatientWeights",
  LATEST_WEIGHT: "LatestWeight",
  BATCH: "Batch",
  PREFERRED_PHARMACY: "PreferredPharmacy",
  PHARMACY_SEARCH: "PharmacySearch",
  ENCOUNTERS: "Encounter",
} as const;
